import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00cf5289"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "プロジェクト一覧", -1))
const _hoisted_2 = { class: "mt20" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新規追加")
const _hoisted_4 = { class: "deleted-link" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("削除済み一覧へ")

import { useStore } from "vuex";
import { onMounted, reactive, computed } from 'vue'
import { Project } from '@/types/project'
import ProjectAddDialog from '@/components/project/ProjectAddDialog.vue'
import ProjectEditDialog from '@/components/project/ProjectEditDialog.vue'
import ProjectDeleteDialog from '@/components/project/ProjectDeleteDialog.vue'
import ProjectList from '@/components/project/ProjectList.vue'
import { ProjectRepository } from '@/repositories/ProjectRepository'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const managerFlg = computed(() => store.state.login.manager_flg);
const repository: ProjectRepository = new ProjectRepository();

const projects: {
  list: Project[],
  loading: boolean,
} = reactive({
  list: [],
  loading: false,
});

onMounted(async (): Promise<void> => {
  projects.loading = true;
  projects.list = await repository.getList();
  projects.loading = false;
});

const dialogs = reactive({
  addForm: {
    visible: false,
    loading: false,
    handleOpen: (): void => {
      dialogs.addForm.visible = true;
    },
    handleSubmit: async (name: string): Promise<void> => {
      dialogs.addForm.visible = false;
      projects.loading = true;
      await repository.add(name);
      projects.list = await repository.getList();
      projects.loading = false;
    },
  },
  editForm: {
    editProject: {},
    visible: false,
    loading: false,
    handleOpen: (project: Project): void => {
      dialogs.editForm.editProject = project;
      dialogs.editForm.visible = true;
    },
    handleSubmit: async (project: Project): Promise<void> => {
      dialogs.editForm.visible = false;
      projects.loading = true;
      await repository.update(project);
      projects.list = await repository.getList();
      projects.loading = false;
    },
  },
  deleteForm: {
    deleteProject: {},
    visible: false,
    loading: false,
    handleOpen: (project: Project): void => {
      dialogs.deleteForm.deleteProject = project;
      dialogs.deleteForm.visible = true;
    },
    handleSubmit: async (project: Project): Promise<void> => {
      projects.loading = true;
      dialogs.deleteForm.visible = false;
      await repository.delete(project);
      projects.list = await repository.getList();
      projects.loading = false;
    },
  },
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(managerFlg))
    ? (_openBlock(), _createBlock(_component_el_container, {
        key: 0,
        class: "container"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, { class: "container__card" }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _unref(dialogs).addForm.handleOpen
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(ProjectAddDialog, {
                  onSubmit: _unref(dialogs).addForm.handleSubmit,
                  modelValue: _unref(dialogs).addForm.visible,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialogs).addForm.visible) = $event))
                }, null, 8, ["onSubmit", "modelValue"]),
                _createVNode(ProjectEditDialog, {
                  modelValue: _unref(dialogs).editForm.visible,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialogs).editForm.visible) = $event)),
                  onSubmit: _unref(dialogs).editForm.handleSubmit,
                  editProject: _unref(dialogs).editForm.editProject
                }, null, 8, ["modelValue", "onSubmit", "editProject"]),
                _createVNode(ProjectDeleteDialog, {
                  modelValue: _unref(dialogs).deleteForm.visible,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialogs).deleteForm.visible) = $event)),
                  onSubmit: _unref(dialogs).deleteForm.handleSubmit,
                  deleteProject: _unref(dialogs).deleteForm.deleteProject
                }, null, 8, ["modelValue", "onSubmit", "deleteProject"]),
                _withDirectives(_createVNode(ProjectList, {
                  projects: _unref(projects).list,
                  onOnEdit: _unref(dialogs).editForm.handleOpen,
                  onOnDelete: _unref(dialogs).deleteForm.handleOpen
                }, null, 8, ["projects", "onOnEdit", "onOnDelete"]), [
                  [_directive_loading, _unref(projects).loading]
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_router_link, {
                    to: "/deleted_projects",
                    class: "button-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, null, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})